// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3N9xo","top":"styles_top__1l6Ke","left":"styles_left__3LI9J","description":"styles_description__1N3UX"};